import qs from 'qs'
import axios from 'axios'
import customAxios from '@core_utils/api/_axios'
import FileApiError from '@core/utils/api/FileApiError'
import { FileDeleteError, DirectUploadError, RequirePresignedUrlError, S3DBSyncronizeError, NotifyUploadError } from '@core/utils/api/FileApiError'

export const requirePresignedPost = async(filenameList, requestParams) => {
    try {
        const response = await customAxios.get('/require_presigned_url', {
            params: {
                ...requestParams, filename: filenameList
            },
            paramsSerializer: (params) => {
                return qs.stringify(params, { indices: false })
            }
        })

        return response.data.result
    } catch (error) {
        throw new RequirePresignedUrlError("Require Presigned Post Error",error)
    }
}


export const postFileToPresignedUrl = async (fileList, presignedValues, logFunc) => {
    try {
        for await (const [_presigned_idx, _presigned] of presignedValues.entries()) {
            const fields = _presigned.fields
            const targetFile = fileList[_presigned_idx]
            const formData = new FormData()

            for (const key in fields) {
                formData.append(key, fields[key])
            }

            formData.append('file', targetFile)
            logFunc("File Object" , `Before Post File ${targetFile.name},${targetFile.size},${targetFile.type}`)
            try {
                await axios.post(_presigned.url, formData)
            } catch (error) {
                console.log(error)
                console.log("Directly Upload Failed, Try another Way Via Server")
                try {
                    // use same form data it contain file, key ..etc
                    await customAxios.post('/v2/save_file_attachment',formData)
                }catch (error2){
                    console.log(error2)
                    Promise.reject(`올바른 반환값이 아닙니다. on Upload ${targetFile.name}`)
                }
            }

            await new Promise(resolve => setTimeout(resolve, 1500))
          }

        return true
    } catch (error) {
        throw new DirectUploadError("Upload file to S3 Directly Error", error)
    }
}




const s3PathGenerator = (filename,{
    campaign_id,
    company_id,
    sub_code
}) => `https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/${campaign_id}/${company_id}/${sub_code}/${filename}`


export const notifyPost = async (filenameList, requestParams) => {
    try {
        let filename = filenameList
        const callbackResult = await customAxios.put('/upload_file_callback', null, {
            params: { ...requestParams, filename },
            paramsSerializer: (params) => {
                return qs.stringify(params, { indices: false })
            }
        })

        if (callbackResult?.data?.success?.length < 1) {
            throw new S3DBSyncronizeError("Fail DB Syncronize (0 Success)")
        }

        return callbackResult.data.success.map((v) => {
            return {
                ...v,
                savepath: s3PathGenerator(v.filename, requestParams)
            }
        })
    } catch (error) {
        if (error instanceof FileApiError){
            throw error
        }
        throw new NotifyUploadError("Notify Upload Error",error)
    }
}


export const getSubFilesInfo = async (requestParams) => {
    const response = await customAxios.get('/get_sub_files',
        { params: requestParams}
    )

    return response.data.result.map((filename) => {
        return {
            filename,
            savepath : s3PathGenerator(filename,requestParams)}
    })
}


export const deleteFile = async (filename,requestParams) => {
    try {
        await customAxios.delete('/delete_file_v2', {
            params: {filename,...requestParams}
        })
        return  
    } catch (error) {
        throw FileDeleteError("Error deleting file",error)
    }
}


export const requirePresignedUrl = async (prefix) => {
    try {
        const response = await customAxios.get(`/document/file/${prefix}`)
        return response.data
    } catch (error) {
        console.log(error)
        throw error
    }
}
